<template>
  <div>
    <div class="container-1170">
      <div class="page-content">
        <div class="page-content-wrapper">
          <el-scrollbar :height="store.state.windowHeight - 130 + 'px'">
            <router-view></router-view>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from "vue";
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj =  reactive({
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('event')
    })

    // 处理Sidebar传来的URL
    vueEvent.on('event',(url) => {
      router.push(url)
    })

    return {
      obj,
      store
    }
  }
}
</script>
<style lang="scss" scoped>
.page-content {
  padding-left: 250px;
  height: 100%;
}
.page-content-wrapper {
  width: 920px;
  padding: 40px 40px;
  margin: 0 auto;
  word-wrap: break-word;
  height: 100%;
}
</style>
